import { Component, Input } from '@angular/core';

import { FieldOkItemComponent } from '@softline/dynamic';

@Component({
  selector: 'soft-field-ok-kasse-data-view',
  imports: [],
  templateUrl: './kasse.list-view.html',
  styleUrls: ['./kasse.list-view.css'],
})
export class KasseListView implements FieldOkItemComponent<any> {
  @Input() item: any;

  constructor() {}
}
